import { faMinusCircle, faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import React, { useEffect, useRef, useState } from 'react';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledIntro,
  StyledIntroImage,
  StyledIntroTitle,
  StyledShowMore,
  StyledSummary,
  StyledSummaryItem,
  StyledSummaryValue,
  StyledText
} from './StateOfHiringIntro.styled';

const StateOfHiringIntro: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  const [displayReadMore, setdisplayReadMore] = useState(false);

  const clampableText = useRef<HTMLDivElement>(null);

  function checkLineClamp(): void {
    if (
      clampableText.current &&
      clampableText.current.clientHeight < clampableText.current.scrollHeight
    ) {
      setdisplayReadMore(true);
    } else {
      setdisplayReadMore(false);
    }
  }

  useEffect(() => {
    checkLineClamp();
  }, []);

  const [showAllText, setShowAllText] = useState(false);

  const items = [
    {
      value: t('state-of-hiring.intro.summary.time-to-hire-value'),
      desc: t('state-of-hiring.intro.summary.time-to-hire')
    },
    {
      value: t('state-of-hiring.intro.summary.tests-value'),
      desc: t('state-of-hiring.intro.summary.tests')
    },
    {
      value: t('state-of-hiring.intro.summary.fee-value'),
      desc: t('state-of-hiring.intro.summary.fee')
    },
    {
      value: t('state-of-hiring.intro.summary.success-rate-value'),
      desc: t('state-of-hiring.intro.summary.success-rate')
    },
    {
      value: t('state-of-hiring.intro.summary.turnover-value'),
      desc: t('state-of-hiring.intro.summary.turnover')
    },
    {
      value: t('state-of-hiring.intro.summary.candidates-value'),
      desc: t('state-of-hiring.intro.summary.candidates')
    }
  ];

  return (
    <StyledContainer>
      <StyledIntro>
        <StyledIntroImage>
          <img
            src={getPublicPath('/images/stateOfHiring/team.jpg')}
            alt="Manfred Team"
          />
        </StyledIntroImage>
        <div>
          <StyledIntroTitle>
            {t('state-of-hiring.intro.title')}
          </StyledIntroTitle>
          <StyledText
            ref={clampableText}
            className={`${showAllText ? 'display-full-text' : ''}`}
          >
            <HtmlTrans
              i18nKey="state-of-hiring.intro.desc"
              ns="state-of-hiring"
            />
          </StyledText>
          {displayReadMore && (
            <StyledShowMore>
              <button onClick={(): void => setShowAllText(!showAllText)}>
                {!showAllText && <FontAwesomeIcon icon={faPlusCircle} />}
                {showAllText && <FontAwesomeIcon icon={faMinusCircle} />}
                <span>
                  {!showAllText && <>{t('state-of-hiring.intro.readMore')}</>}
                  {showAllText && <>{t('state-of-hiring.intro.readLess')}</>}
                </span>
              </button>
            </StyledShowMore>
          )}
        </div>
      </StyledIntro>
      <Heading1 as="h2" editorial>
        {t('state-of-hiring.intro.summary.title')}
      </Heading1>
      <StyledSummary>
        {items.map((item, index) => (
          <StyledSummaryItem key={index}>
            <StyledSummaryValue>{item.value}</StyledSummaryValue>
            <p>
              <HtmlTrans i18nKey={item.desc} ns="state-of-hiring" />
            </p>
          </StyledSummaryItem>
        ))}
      </StyledSummary>
    </StyledContainer>
  );
};

export default StateOfHiringIntro;
